import type { SportsMenuState } from './types';

export const defaultState: SportsMenuState = {
  preloaded: false,
  popular: [],
  az: []
};
